import React, { useState } from 'react';
import './menu.css';
import logo from '../../assets/images/logo.png';
import { Link, useLocation } from 'react-router-dom';

const navItem = [
  { id: 0, itemName: 'Home', url: '/' },
  { id: 1, itemName: 'About', url: '/about' },
  { id: 2, itemName: 'What We Do', url: '/whatwedo' },
  { id: 3, itemName: 'Contact', url: '/contact' },
];

export default function Menu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const menuList = navItem.map((navList) => (
    <li key={navList.id} className={location.pathname === navList.url ? 'active' : ''}>
      <Link to={navList.url} onClick={() => setIsMenuOpen(false)}>
        {navList.itemName}
      </Link>
    </li>
  ));

  return (
    <nav className="menu">
      <div className="container d-flex justify-content-between align-items-center py-3">
        {/* Logo Section */}
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Website logo" />
          </Link>
        </div>

        {/* Hamburger Icon */}
        <div
          className={`hamburger ${isMenuOpen ? 'is-active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Navigation Menu */}
        <ul className={`nav-links d-flex align-items-center ${isMenuOpen ? 'show' : ''}`}>
        <li className="d-flex d-md-none align-items-center callto">
            <figure>
              <i className="fas fa-phone-alt"></i>
            </figure>
            <Link to="tel:+917307078055" onClick={() => setIsMenuOpen(false)}>
              Call Us <span className="d-block">+91 73070 78055</span>
            </Link>
          </li>
          {menuList}
          <li className="d-md-flex d-none align-items-center callto">
            <figure>
              <i className="fas fa-phone-alt"></i>
            </figure>
            <Link to="tel:+917307078055" onClick={() => setIsMenuOpen(false)}>
              Call Us <span className="d-block">+91 73070 78055</span>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
